import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import AuthService from "../services/AuthService";
import { AuthProvider, IfFirebaseAuthed, IfFirebaseUnAuthed } from "../context/FirebaseAuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGoogle, faYahoo } from "@fortawesome/free-brands-svg-icons";

import "../assets/style/signup.css";

import Logo from "../assets/images/logo-footer.png";

const Subheader = () => (
	<section id="sub-header">
		<img src={Logo} alt="no fap guidance" />
	</section>
);

const Form = () => {

	const auth = new AuthService();

	const [ success, setSuccess ] = useState(false);
	const [ pending, setPending ] = useState(false);
	const [ error, setError ] = useState("");
	const [ input, setInput ] = useState({
		email: "",
		name: "",
		password: "",
		repeatPassword: ""
	})

	const handleInput = ({ target }) => {
		setInput({
			...input,
			[target.name]: target.value
		});
	};

	const signUp = async (e) => {
		e.preventDefault();
		
		setPending(true);
		setError("");

		try {
			
			await auth.signUpEmail(input.email, input.name, input.password, input.repeatPassword);
		
			setSuccess(true);
		}
		catch(error) {
			setError(error.message);
			setPending(false);
			setSuccess(false);
		}
	}
	const authThirdParty = async (e, provider) => {
		
		e.preventDefault();

		setPending(true);
		setError("");

		try {
			
			if(provider === 1) await auth.authorizeGoogle();
			else if(provider === 2) await auth.authorizeYahoo();
			else if(provider === 3) await auth.authorizeFacebook();
		
			setSuccess(true);
		}
		catch(error) {
			setError(error.message);
			setPending(false);
			setSuccess(false);
		}
	}


	return (
		<form id="auth-signup" onSubmit={signUp}>
			<h1>Sign up</h1>
			{ error.length > 0 && <h3>{error}</h3> }
			{ success && <Redirect to="/" /> }
			<section id="providers">
				<button type="button" onClick={(e) => authThirdParty(e, 1)}><FontAwesomeIcon icon={faGoogle} /> Sign in with Google</button>
				<button type="button" onClick={(e) => authThirdParty(e, 2)}><FontAwesomeIcon icon={faYahoo} /> Sign in with Yahoo</button>
				<button type="button" onClick={(e) => authThirdParty(e, 3)}><FontAwesomeIcon icon={faFacebook} /> Sign in with Facebook</button>
			</section>
			<div>
				<label>E-mail:</label>
				<br />
				<input 
					type="email" 
					name="email" 
					disabled={pending}
					onChange={e => handleInput(e)} 
					placeholder="johnsmith@hotmail.com" 
				/>
			</div>
			<div>
				<label>Name:</label>
				<br />
				<input 
					type="name" 
					name="name" 
					disabled={pending}
					onChange={e => handleInput(e)} 
					placeholder="JohnSmith123" 
				/>
			</div>
			<div>
				<label>Password:</label>
				<br />
				<input 
					type="password" 
					name="password" 
					disabled={pending}
					onChange={e => handleInput(e)} 
					placeholder="•••••••••••" 
				/>
			</div>
			<div>
				<label>Repeat Password:</label>
				<br />
				<input 
					type="password" 
					name="repeatPassword"  
					disabled={pending}
					onChange={e => handleInput(e)} 
					placeholder="•••••••••••" 
				/>
			</div>
			<button id="submit" type="submit" disabled={pending} >Create an Account</button>
			<p>Already have an account? <Link to="/auth/login">Login</Link>!</p>
		</form>
	);
}

const SignupPage = () => {

	return (
		<>
			<AuthProvider>
				<IfFirebaseAuthed>
					<Redirect to="/"/>
				</IfFirebaseAuthed>
				<IfFirebaseUnAuthed>
					<Subheader />
					<Form />
				</IfFirebaseUnAuthed>
			</AuthProvider>
		</>
	);
};

export default SignupPage;